import { render, staticRenderFns } from "./NoDrawn.vue?vue&type=template&id=1b6a20c6&scoped=true"
import script from "./NoDrawn.vue?vue&type=script&lang=js"
export * from "./NoDrawn.vue?vue&type=script&lang=js"
import style0 from "./NoDrawn.vue?vue&type=style&index=0&id=1b6a20c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a20c6",
  null
  
)

export default component.exports